import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { BaseService } from '../../services/base.service';
import { UserService } from '../../services/user.service';
import { MapService } from '../../services/map.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {

  mapLoadedChangeSubscription: Subscription;
  mapLoadedChangeSubscription2: Subscription;
  goToMapListner: any;

  constructor(public userService: UserService, public baseService: BaseService, public mapService: MapService) { }

  ngOnInit() {
    let w = (<any>window),
    searchInput = document.getElementById('pac-input');
        
    this.userService.clearLS();
    this.resetMapToDefault();

    if(!w.mmap.isMobileMode()) {
      this.mapService.addMapResizeInterval();
      (<any>window).domBody.classList.add('search-home');
      (<HTMLInputElement>searchInput).placeholder = 'Address, Neighborhood, City, or Zip';
      if(!this.goToMapListner) {
        this.goToMapListner = document.getElementById('go-to-map').addEventListener('click', ()=> {
          w.Events.publish('goToMap');
        });
      }
    } else {
      w.Events.publish('goToMap');
    }

    setTimeout(()=>{
      this.closeAllAddStuffProcesses();
      searchInput.focus();
    },0);
  }

  closeAllAddStuffProcesses() {
    let w = (<any>window);
    this.mapLoadedChangeSubscription2 = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        w.Events.publish('closeAddPropertyFlow');
        w.Events.publish('closeAddRetailerFlow');
        w.Events.publish('closeAddPinFlow');
      }
    });
  }

  resetMapToDefault() {
    let w = (<any>window);
    this.mapLoadedChangeSubscription = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        if(w.map.getBounds()) {
          this.clearUserMapOnReset();
          w.saveMap.resetMapToDefault();
        } else {
          w.google.maps.event.addListenerOnce(w.map, 'bounds_changed', ()=>{
            this.clearUserMapOnReset();
            w.saveMap.resetMapToDefault();
          });
        }
      }
    });
  }

  clearUserMapOnReset() {
    let w = (<any>window);
    if(this.mapService.currentUserMap) {
      w.localStorageHandler.removeMapAccessIdFromLS();
      w.saveMap.deleteUserBoundsPolygon();
      w.saveMap.isMapReceived = false;
      this.mapService.currentUserMap = null;
      w.saveMap.previousUnsaved = null;
      this.mapService.checkIfMapIsReceived(false);
      w.domBody.classList.remove('user-map');
    }
  }

  ngOnDestroy() {
    this.mapLoadedChangeSubscription && this.mapLoadedChangeSubscription.unsubscribe();
    this.mapLoadedChangeSubscription2 && this.mapLoadedChangeSubscription2.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts